<!--
 * @Description  : 购票须知中的学生票须知
-->
<template minapp="mpx" xlang="wxml">
  <view>
    <notes isShowTabIcon="{{isShowTabIcon}}" class="notes1" notesList="{{notesList1}}">
      <view slot="tabrefund" wx:style="{{ {marginTop: '-12px'}}}">
        <refund-table tableValue="{{tableValue1}}"></refund-table>
      </view>
    </notes>
    <view wx:style="{{ {background: '#fff', borderRadius: '8px'} }}">
      <notes class="notes2" notesList="{{notesList2}}"></notes>
      <refund-table class="refund1" tableValue="{{tableValue2}}" wx:style="{{ {marginTop: '-12px'}}}"></refund-table>
    </view>
    <explain class="explain1" explainValue="{{explainValue1}}"></explain>
    <explain class="explain2" explainValue="{{explainValue2}}"></explain>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    data: {
      isShowTabIcon: true,
      notesList1: [
        {
          title: '学生票价格说明',
          list: ['学生票优惠价格可参考下方表格，具体以占座成功后的价格为准。']
        }
      ],
      tableValue1: {
        tabWidth: '100px',
        tableth: ['坐席分类', '车票优惠'],
        tablelist: [
          {
            title: '二等座',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '公布'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '票价75%'
                  }
                ]
              }
            ]
          },
          {
            title: '硬座',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '折扣为'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '全票价50%'
                  }
                ]
              }
            ]
          },
          {
            title: '硬卧',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '硬卧全价'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '-50%硬座全价'
                  }
                ]
              }
            ]
          }
        ],
        caveat: '硬卧有空调时，再收取半价空调费用'
      },

      notesList2: [
        {
          title: '学生票使用规则',
          subTitle: '适用人群',
          list: [
            '持有学生优惠卡的大学生',
            '新生（凭录取通知书可购票取票） ',
            '毕业生（凭学校开具的书面证明可购票取票）',
            '没有工资收入的学生、研究生'
          ]
        }
      ],
      tableValue2: {
        tabWidth: '100px',
        tableth: ['规则类型', '具体说明'],
        tablelist: [
          {
            title: '乘车时间',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '无寒暑假限制，全年均可购票'
                  }
                ]
              }
            ]
          },
          {
            title: '支持坐席',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '无座、硬座、硬卧、二等座(其他座席需购买成人票)'
                  }
                ]
              }
            ]
          },
          {
            title: '乘坐区间',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '优惠区间内:家庭至院校(实习地点)'
                  }
                ]
              }
            ]
          },
          {
            title: '使用次数',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '每年限于'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '4次单程'
                  }
                ]
              }
            ],
            tip: '注:当年未使用的次数不能留至下年使用'
          }
        ],
        caveat:
          '温馨提示：自2023年1月1日起，学生票不再受到寒暑假乘坐时间的限制，全年都可以购买。一年的计数周期从10月1日至次年9月30日。'
      },
      explainValue1: {
        title: '学生票如何取?',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 取票条件：需携带购票证件原件＋学生优惠卡'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 取票地点：车站售票窗口、车站自动售取票机 '
                }
              ]
            }
          ]
        ],
        tip: '注：符合购买学生票条件的应到车站指定售票窗口或自动售／取票机办理本人居民身份证件与学生优惠卡的核验手续（学生票需每学年乘车前办理一次）'
      },
      explainValue2: {
        title: '学生票如何退?',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 根据铁路局规定，自2021年3月16日起，学生票退票按成人票退票规则收取手续费。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 若已使用学生票优惠次数，退票时将会退还次数；改签不会再次占用学生票次数。'
                }
              ]
            }
          ]
        ]
      }
    },
    mounted() {},
    computed: {},

    methods: {}
  })
</script>

<style scoped lang="stylus">
  .explain1
    margin-bottom 12px
    margin-top 12px
  .explain2
    margin 12px 0
  .notes1
    margin-bottom 12px
    border-radius 8px
  .notes2
    border-radius 8px 8px 0 0
  .refund1
    border-radius 0 0 8px 8px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      explain: '@/components/ticket-guide/explain',
      notes: '@/components/ticket-guide/notes',
      'ticket-table': '@/components/ticket-guide/ticket-table',
      'refund-table': '@/components/ticket-guide/refund-table'
    }
  }
</script>